/* theme-sync-rev: 2026-09-07c-sync-fix — bump on every change to this file.
   The flavour guide's markup + CSS live in
   sections/kkumi-product-sleeve-guide.liquid, the behaviour here, and the
   dev->Shopify sync is per-file: one can land without the other. Both carry
   this string; the section publishes it as data-kkpsg-build on its root, and
   the check below names a mismatch (or a stale section) in the console. */
var KKPSG_BUILD = '2026-09-07c-sync-fix';
  (function () {
    var root = document.querySelector('.kkpsg [data-kkpsg-pager-root]');
    if (!root) return;
    var host = document.querySelector('.kkpsg[data-kkpsg-build]');
    var live = host ? host.dataset.kkpsgBuild : '(none - stale section file)';
    if (live !== KKPSG_BUILD) {
      console.warn('kkumi-product-sleeve-guide: build mismatch - section ' + live + ', script ' + KKPSG_BUILD);
    }
    var pages = Array.prototype.slice.call(root.querySelectorAll('[data-kkpsg-page]'));
    if (pages.length <= 1) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kkpsg-dot]'));
    var prev = root.querySelector('[data-kkpsg-prev]');
    var next = root.querySelector('[data-kkpsg-next]');
    var current = parseInt(root.dataset.activePage || '0', 10) || 0;

    function show(n) {
      if (n < 0 || n >= pages.length || n === current) return;
      pages.forEach(function (p, i) { p.hidden = i !== n; });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === n);
        d.setAttribute('aria-selected', i === n ? 'true' : 'false');
      });
      if (prev) prev.disabled = n === 0;
      if (next) next.disabled = n === pages.length - 1;
      current = n;
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(Math.min(pages.length - 1, current + 1)); dots[current].focus(); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); show(Math.max(0, current - 1)); dots[current].focus(); }
      });
    });
  })();
